import React, { useEffect, useMemo } from 'react';
import { Container, Grid, NoSsr } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import OrgProfileHeader from 'components/organization/OrgProfileHeader';
import AffiliatedOrganizations from 'components/organization/AffiliatedOrganizations';
import UpcomingAndPastEvents from 'components/organization/UpcomingAndPastEvents';
import Footer from 'components/home/Footer';
import { trackPage } from './ScrenTracker';

const useStyles = makeStyles()((theme) => ({
  mainContainer: {
    padding: theme.spacing(12, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(5, 0),
    },
  },
  eventsContainer: {
    backgroundColor: 'white',
    overflowX: 'hidden',
  },
}));

interface OrganizationScreenProps {
  organization: any;
  upcomingEvents: any[];
  pastEvents: any[];
  isPastEventFetching: boolean;
  isUpcomingEventFetching: boolean;
  onToggleFavoriteEvent?: any;
}

const OrganizationScreen: React.FC<OrganizationScreenProps> = ({
  organization,
  upcomingEvents,
  pastEvents,
  isPastEventFetching,
  isUpcomingEventFetching,
  onToggleFavoriteEvent,
}) => {
  const { id, images, family_tree: familyTree } = organization;
  const { classes } = useStyles();

  const mainImage = images.find((image: any) => image.main === true);

  const reportButtonUrl = useMemo(
    () => (id === 44 ? 'https://forms.monday.com/forms/e18d251a41a5ee9bb6faa66854d7a579?r=use1&source=Jlive' : ''),
    [id],
  );

  useEffect(() => {
    trackPage('Organisation Page');
  }, []);

  return (
    <NoSsr>
      <OrgProfileHeader organization={organization} reportButtonUrl={reportButtonUrl} />

      <div className={classes.eventsContainer}>
        <Container maxWidth="lg">
          <Grid container className={classes.mainContainer}>
            <Grid item xs={12}>
              <UpcomingAndPastEvents
                organizationId={id}
                upcomingEvents={upcomingEvents}
                pastEvents={pastEvents}
                isPastEventFetching={isPastEventFetching}
                isUpcomingEventFetching={isUpcomingEventFetching}
                onToggleFavoriteEvent={onToggleFavoriteEvent}
              />
            </Grid>
          </Grid>
        </Container>
      </div>

      {familyTree.length > 0 && (
        <AffiliatedOrganizations
          organizations={familyTree}
          backgroundImage={mainImage?.image?.original_url}
          className={classes.mainContainer}
        />
      )}
      <Footer />
    </NoSsr>
  );
};

export default OrganizationScreen;
